import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary',
  fullWidth = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cream';
  const variants = {
    primary: 'bg-sage text-white hover:bg-sage-dark shadow-lg shadow-sage/20 focus:ring-sage',
    secondary: 'bg-white text-brown-heading border-2 border-sage/20 hover:border-sage/50 hover:bg-sage-light focus:ring-sage'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const sizeClass = 'px-8 py-4 text-lg';
  const allStyles = `${baseStyles} ${variants[variant]} ${widthClass} ${sizeClass} ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={allStyles} onClick={onClick} data-id="element-210">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={allStyles} onClick={onClick} data-id="element-211">
      {children}
    </motion.button>;
}